import styled from "styled-components";
import DesignConstants from "../../../../constants/DesignConstants";

export const ExerciseWrapper = styled.div<{ disabled?: boolean }>`
    display: flex;
    background: white;
    overflow: hidden;
    border: ${DesignConstants.BORDERS.THIN_GREY};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
    }
`;

export const ExerciseTitleAndInfoWrapper = styled.div<{ disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    opacity: ${(props) => (props.disabled ? DesignConstants.OPACITY.HALF : 1)};
`;

export const ExerciseTitleSideWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 3;
    justify-content: center;
    gap: ${DesignConstants.SPACES.M};
    padding: ${DesignConstants.SPACES.L};

    &.infoOpen {
        flex: 1;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        order: 2;
        padding: ${DesignConstants.SPACES.S};
        gap: ${DesignConstants.SPACES.S};
        position: relative;
        z-index: 1;
        background: white;
        margin-top: -${DesignConstants.SPACES.M};
        border-top: ${DesignConstants.BORDERS.THIN_GREY};
    }
`;

export const ExerciseImageSideWrapper = styled.div`
    display: flex;
    flex: 4;
    overflow: hidden;
    position: relative; //to anchor the absolute children
    border-left: ${DesignConstants.BORDERS.THIN_GREY};

    &.infoOpen {
        flex: 1;
        align-self: stretch;
        align-items: center;
        border-left: none;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        order: 1;
        flex: none;
        height: 100px;
        min-height: 0;
        border-left: none;

        &.infoOpen {
            flex: none;
            height: 100px;
        }
    }
`;

export const ExerciseTypeImageWrapper = styled.div<{ disabled?: boolean }>`
    display: flex;
    height: 100%;
    width: 100%;
    position: absolute; //needed to properly cut the images
    align-items: flex-start;
    padding: ${DesignConstants.SPACES.S};

    opacity: ${(props) => (props.disabled ? DesignConstants.OPACITY.HALF : 1)};

    &.infoOpen {
        align-items: center;
        padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.L} ${DesignConstants.SPACES.S}
            ${DesignConstants.SPACES.S};
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.S} 0;
        box-sizing: border-box;

        &.infoOpen {
            padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.S} 0;
            align-items: flex-start;
        }
    }
`;

export const ExerciseTypeImage = styled.img`
    width: 100%;
    object-fit: cover;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        align-self: flex-start;
        height: auto;
    }
`;

export const ExerciseNameQuestionmarkWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        justify-content: space-between;
        width: 100%;
    }
`;

export const ExerciseInfo = styled.p`
    font-size: ${DesignConstants.FONT_SIZES.S};
`;

export const StyledQuestionMarkIcon = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${DesignConstants.FONT_SIZES.XL};
    color: ${DesignConstants.COLORS.DARK_GREY};
`;

export const ExerciseQuestionMarkWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
        color: ${DesignConstants.COLORS.P6_ORANGE};
        ${StyledQuestionMarkIcon} {
            color: ${DesignConstants.COLORS.P6_ORANGE};
        }
    }

    &.infoOpen {
        ${StyledQuestionMarkIcon} {
            color: ${DesignConstants.COLORS.P6_ORANGE};
        }
    }
`;

export const ExerciseDescriptionWrapper = styled.div<{ disabled?: boolean }>`
    display: flex;
    border-left: 4px solid ${DesignConstants.COLORS.P6_ORANGE};
    padding: 0 ${DesignConstants.SPACES.M};
    font-size: ${DesignConstants.FONT_SIZES.M};
    line-height: 1.5;
    color: ${DesignConstants.COLORS.DARK_GREY};
    hyphens: auto;
    text-align: left;

    opacity: ${(props) => (props.disabled ? DesignConstants.OPACITY.HALF : 1)};
`;
